import { render } from "./WixtarPanel.vue?vue&type=template&id=59118cb5&scoped=true"
import script from "./WixtarPanel.vue?vue&type=script&lang=js"
export * from "./WixtarPanel.vue?vue&type=script&lang=js"

import "./WixtarPanel.vue?vue&type=style&index=0&id=59118cb5&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59118cb5"]])

export default __exports__